<!--能流图配置页面-->
<template>
	<div class="energyFlowConfigBody" >
		<div class="energy-menu">
			<span class="selDate">选择日期：</span>
			<div class="block">
				<el-date-picker v-model="dataTime" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" 
				:picker-options="pickerOptions" @change="inquire()">
				</el-date-picker>
			</div>
			<el-button type="primary" plain size="mini" style="margin-left: 5px;" @click="inquire()">查询</el-button>
			<el-button type="primary" plain size="mini" style="margin-left: 5px;" @click="editShow = true">编辑</el-button>
		</div>
		<el-dialog title="编辑" id='myPanel' :visible.sync="editShow" class="customWidth">
			<el-button type="primary" v-if="energyTree.length == 0" size="mini" plain @click="deviceListShow=true">添加</el-button>
			<el-scrollbar>
				<el-tree :data="energyTree" node-key="id" :props="defaultProps" :highlight-current='true' default-expand-all :filter-node-method="filterNode" ref="tree" @node-click="nodeClick">
					<span class="custom-tree-node" slot-scope="{node, data}">
					<span style="padding-left: 5px;">{{node.label}}</span>
					<button style="display:none"></button>
					<el-button style="margin-left: 15px;" @click="selectNode=data,deviceListShow=true" icon="el-icon-plus" size="mini" circle></el-button>
					<el-button @click="deleteNode(node)" icon="el-icon-minus" size="mini" circle></el-button>
					</span>
				</el-tree>
			</el-scrollbar>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="editShow = false">取 消</el-button>
				<el-button size="mini" type="primary" @click="editShow = false">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="选择设备" :visible.sync="deviceListShow" append-to-body class="customWidth selDev">
			<elRadioTree style="height:500px;" :dataList='virtualDeviceList' @checkItem="deviceCheckItem"></elRadioTree>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="deviceListShow = false">取 消</el-button>
				<el-button size="mini" type="primary" @click="addNode()">确 定</el-button>
			</div>
		</el-dialog>
		<!--能流图数据流向-->
		<div class="energy-main" v-on:click="hidePanel">
			<vchart ref='vchart' style="height: 98%;"></vchart>
		</div>
	</div>
</template>

<script>
	import elRadioTree from '@/components/module/tree/elRadioTree.vue'
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			elRadioTree,
			vchart,
		},
		props: {},
		data() {
			return {
				dataTime: [new Date(), new Date()],
				editShow: false,
				deviceListShow: false,
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				pickerOptions: {
					shortcuts: [{
						text: '最近一周',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近一个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近三个月',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				energyTree: [],
				selectDevice: {},
				selectNode: {}, //选中添加的节点
				options: {
					title: {
						text: '能源流向',
						left: 'center',
						textStyle: {
							fontWeight: 800,
							fontSize: 22,
						}
					},
					tooltip: {
						trigger: 'item',
						triggerOn: 'mousemove'
					},
					series: [],
				},
				links: [],
				nodes:[],
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			this.initData()
			this.inquire()
			this.$refs.vchart.setData(this.options, true)
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [deviceList(data)]
			},
			nowVirtualDevice() {
				//选中设备的缓存
				return this.$store.deviceStore.state.nowVirtualDevice
			},
			
		},
		watch: {
			nowUnit(nv, ov) {
				//切换单位刷新数据
				this.initData()
				this.inquire()
			}
		},
		methods: {
			hidePanel(event){
				var sp = document.getElementById("myPanel");
				if(sp){
					if(!sp.contains(event.target)){//如果我们点击到了id为myPanel以外的区域
						if(this.deviceListShow){
							this.editShow = true
						}else{
							this.editShow = false
						}
						this.deviceListShow = false
					}
				}
			},
			initData() {
				//获取单位能流图树
				this.$api.energyFlowApi.getEnergyFlowConfigTree(this.nowUnit.id, respon => {
					this.energyTree = energyFlowList(respon)
				})
			},

			inquire() {
				//查询数据
				let beginTime = new Date(new Date(this.dataTime[0]).format('yyyy-MM-dd') + ' 00:00:00').getTime()
				let endTime = new Date(this.dataTime[1]).getTime()
				this.$dialogMethod.showLoading('正在加载')
				this.$api.energyFlowApi.getEnergyFlowDiagram(this.nowUnit.id, beginTime, endTime, respon => {
					if(!isempty(respon)) {
						//组合数据
						this.links = []
						this.nodes=[]
						this.diguiData(respon.next)
						this.options.series = [{
							type: 'sankey',
							focusNodeAdjacency: 'allEdges',
							nodeAlign: 'right',
							data:this.nodes,
							links:this.links,
							lineStyle: {
								color: 'source',
								curveness: 0.5
							}
						}]
						console.log(this.options,65656565656565)
						// this.$dialogMethod.closeLoading()
						this.$refs.vchart.setData(this.options, true)
					}
				})
			},
			deviceCheckItem(value) {
				this.selectDevice = value
			},
			addNode() {
				//添加节点
				if(isempty(this.selectDevice)) {
					this.$message.error('请选择设备');
					return
				}
				let unitid = ''
				let parentNo = ''
				if(isempty(this.selectNode.id)) {
					unitid = this.nowUnit.id
				} else {
					parentNo = this.selectNode.id
				}
				//执行添加
				this.$api.energyFlowApi.addEnergyFlowConfig(this.selectDevice.no, this.selectDevice.label, parentNo, unitid, respon => {
					if(!isempty(respon)) {
						this.initData()
						this.inquire()
						this.selectDevice = {}
						this.deviceListShow = false
						this.$message({
							message: "添加成功",
							type: "success"
						})
					}
				},err=>{
					this.$message({
						type: 'error',
						message: err
					});
				})
			},
			deleteNode(item) {
				if(isempty(item.data.deviceNo)){
					return 
				}
				//删除节点
				this.$confirm('确定删除此项及下面所有, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.energyFlowApi.deleteEnergyFlowConfig(item.data.deviceNo, respon => {
						if(!isempty(respon)) {
							this.initData()
							this.inquire()
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			filterNode(value, data) {},
			nodeClick(value, nodeData) {},
			diguiData(data) {
				//递归组合数据
				data.forEach(item => {
					this.nodes.push({name:item.deviceName})
					if(!isempty(item.next)) {
						item.next.forEach(item2 => {
							let obj = {
								source: item.deviceName,
								target:item2.deviceName , //目标
								value: item.power,
							}
							this.links.push(obj)
						})
						this.diguiData(item.next)
					}else{
					}
				})
			}
		}
	}
</script>

<style scoped>
	.energyFlowConfigBody {
		width: 100%;
		height: 100%;
	}
	
	.energy-menu {
		width: 100%;
		height: 5%;
		background-color: white;
		display: flex;
		align-items: center;
	}
	
	.energy-main {
		width: 100%;
		height: 95%;
		background-color: white;
	}
	
	.energy-menu .block {
		margin-left: 20px;
	}
	
	.energy-menu .block .el-date-editor .el-range-input {
		box-shadow: none;
		outline: none;
		resize: none;
		border: none;
		-webkit-appearance: none;
		-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	}
	>>>.elRadioTreeBody{
		width: 100%;
	}
	>>>.el-tree-node__content{
		margin: 0.03rem 0;
	}
	.selDev >>>.el-scrollbar__wrap{
		overflow-x: hidden;
	}
	.selDev{
		overflow-y: hidden;
	}
	.selDate{
		padding-left: 0.2rem;color: black;
		font-size: 0.14rem;
	}
	.customWidth{
		width: 70%;
		margin: 0 auto;
	}
</style>